/*
 * myClass
 */
var LARepublic = function () {
        
    /*
     * Variables accessible
     * in the class
     */
    var vars = {
        //app_draft_api: 'https://apps.leadapparel.net/stagging-checkout-builder.php',
        //app_root: 'https://apps.leadapparel.net/',
        app_draft_api: 'https://checkoutbuilder.appareluniverse.com/stagging-checkout-builder.php',
        app_root: 'https://checkoutbuilder.appareluniverse.com/',
        //app_draft_api: 'https://a313-103-186-78-159.ngrok-free.app/stagging-checkout-builder.php',
        //app_root: 'https://a313-103-186-78-159.ngrok-free.app/',
        filesadded: ''
    }; 



    //intit cart
    this.checkCart = function () {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                window.WR.common.Shopify.cart = JSON.parse(this.responseText);
            }
        };
        xhttp.open("GET", "cart.js");
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.send();
    };

    /*
     * Can access this.method
     * inside other methods using
     * root.method()
     */
    var root = this;

    var getCartToken = function () {
        return getCookie("cart");
    };

    var getCookie = function (t) {
        var e = "; " + document.cookie,
                n = e.split("; " + t + "=");
        if (2 === n.length)
            return n.pop().split(";").shift()
    }

    var getId = function () {
        return window.WR.common.Shopify.customer.id;
    };



    var b64EncodeUnicode = function (str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1);
                }));
    };

    var b64DecodeUnicode = function (str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };


    /*
     * Public method
     * Can be called outside class
     */
    this.getShopKey = function () {
        return vars.sr_token;
    };
    this.isLARInstalled = function () {
        return window.WR.LARepublic.is_installed;
    };
    this.hasTags = function () {
        var t = this.getTags();
        return t && t.length > 0;
    };

    this.isLoggedIn = function () {
        return null !== getId();
    };

    this.getTemplate = function () {
        return window.WR.common.template;
    };
    this.getCheckoutButtons = function () {
        return document.querySelectorAll("[class=LAR-checkout],[name='checkout']");
    };

    this.getTags = function () {
        return window.WR.common.Shopify.customer.tags;
    };

    this.getCart = function () {
        return window.WR.common.Shopify.cart;
    };

    this.getCustomer = function () {
        return  window.WR.common.Shopify.customer;
    };

    this.getProxy = function () {
        return vars.sr_proxy;
    };

    this.getShopUrl = function () {
        return window.WR.common.Shopify.shop.secure_url
    };

    this.getShopDomain = function () {
        return window.WR.common.Shopify.shop.permanent_domain
    };

    this.getDraftOrderBuilderPath = function () {
        return vars.app_draft_api;
    };
    this.getRootPath = function () {
        return vars.app_root;
    };

    this.getVariants = function () {
        return window.WR.common.Shopify.variants || '';
    }

    this.removeFormElement = function (t, eleName) {
        if (t.length > 0) {
            for (i = 0; i < t.length; i++) {
                if (t.elements[i].name.toLowerCase() == eleName.toLowerCase()) {
                    t.remove();
                    return;
                }
            }
        }
    };
    createElement = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                n = document.createElement(t);
        if (null === e)
            return n;
        for (var r in e) {
            var o = e[r];
            switch (r) {
                case "innerHTML":
                    n.innerHTML = o;
                    break;
                case "text":
                    n.appendChild(document.createTextNode(o));
                    break;
                case "click":
                case "onClick":
                    n.addEventListener("click", o);
                    break;
                case "appendChild":
                    n.appendChild(o);
                    break;
                case "appendChildren":
                    for (var i = 0; i < o.length; i++)
                        n.appendChild(o[i]);
                    break;
                default:
                    n[r] = o
            }
        }
        return n
    };


    this.formatMoney = function (money) {
        var format = window.WR.common.Shopify.shop.money_format;
        return window.WR.common.Shopify.formatMoney(money, format);
    }


    this.setLeadApparelOptions = function (t) {
        this.removeFormElement(t, 'shop');
        this.removeFormElement(t, 'cart_id');
        this.removeFormElement(t, 'shopify_customer_id');
        this.removeFormElement(t, 'cart');
        t.action = this.getDraftOrderBuilderPath(), t.appendChild(createElement("input", {
            type: "hidden",
            name: "cart_id",
            value: getCartToken()
        })), t.appendChild(createElement("input", {
            type: "hidden",
            name: "shopify_customer_id",
            value: getId()
        })), t.appendChild(createElement("input", {
            type: "hidden",
            name: "shop",
            value: this.getShopDomain()
        })), t.appendChild(createElement("input", {
            type: "hidden",
            name: "cart",
            value: b64EncodeUnicode(JSON.stringify(this.getCart()))
        }))
    };
};

var LARepublicObj = new LARepublic();
var strTemplate = LARepublicObj.getTemplate();
var variants = LARepublicObj.getVariants();
// console.log(variants);
var customize = 0;
if($('#customize').length > 0){
	customize = document.getElementById('customize').value || 0;
}


if (LARepublicObj.isLARInstalled()) {
    function initLoad() {
        var checkoutBtns = LARepublicObj.getCheckoutButtons();
        if (checkoutBtns.length > 0) {
            checkoutBtns.forEach(function (btn) {
                if (btn.name.toLowerCase() == 'checkout' && customize == 1) {
                    btn.addEventListener("click", function (e) {
                        LARepublicObj.checkCart();
                        LARepublicObj.getCart();
                        LARepublicObj.setLeadApparelOptions(btn.form);
                        $(".LAR-checkout").addClass("eactive");
                    });
                }
            });
        }
    }

    window.addEventListener('load', function () {
        initLoad();
    });
}



